import { SxProps } from "@mui/material/styles";
import React from "react";

import {
  ToggleContainer,
  ToggleIcon,
  ToggleLabel,
  ToggleSize,
  ToggleThumb,
  ToggleTrack,
} from "./Toggle.styles";
import { Icon } from "../../icons";

export interface ToggleProps {
  checked?: boolean;
  disabled?: boolean;
  size?: ToggleSize;
  label?: string | React.ReactElement;
  sx?: SxProps;
  dataCy?: string;
  onChange: (checked: boolean) => void;
}

export const Toggle = ({
  checked = false,
  disabled = false,
  size = "md",
  label,
  sx,
  dataCy,
  onChange,
}: ToggleProps) => (
  <ToggleContainer sx={sx} toggleSize={size}>
    <ToggleTrack
      type="button"
      role="switch"
      aria-checked={checked}
      on={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      data-cy={dataCy}
    >
      <ToggleIcon>
        <Icon icon={checked ? "Check" : "X"} size={size === "lg" ? "sm" : "xs"} weight={2.5} />
      </ToggleIcon>
      <ToggleThumb on={checked} />
    </ToggleTrack>
    {label && <ToggleLabel>{label}</ToggleLabel>}
  </ToggleContainer>
);

Toggle.displayName = "Toggle";
